import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { API_BASE } from '../../config';
import { Home, FolderOpen, Package, FileEdit, AtSign, ChevronDown, ChevronRight } from 'lucide-react';

const NAV_ITEMS = [
    { icon: Home, label: 'Dashboard', to: '/wiki' },
];

export default function WikiSidebar() {
    const location = useLocation();
    const [categories, setCategories] = useState([]);
    const [collapsed, setCollapsed] = useState(false);

    useEffect(() => {
        axios.get(`${API_BASE}/wiki/categories`)
            .then((res) => setCategories(res.data.categories || res.data || []))
            .catch(() => setCategories([]));
    }, []);

    return (
        <nav style={{
            width: '240px',
            minWidth: '240px',
            background: 'var(--bg-secondary)',
            borderRight: '1px solid var(--border)',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            overflowY: 'auto',
        }}>
            {/* Nav items */}
            <div style={{ padding: '0.5rem 0' }}>
                {NAV_ITEMS.map((item) => {
                    const active = location.pathname === item.to;
                    const Icon = item.icon;
                    return (
                        <Link
                            key={item.to}
                            to={item.to}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.65rem',
                                padding: '0.5rem 1rem',
                                color: active ? 'var(--gold)' : 'var(--text-secondary)',
                                background: active ? 'var(--gold-light)' : 'transparent',
                                textDecoration: 'none',
                                fontSize: '0.875rem',
                                fontWeight: active ? 600 : 400,
                            }}
                        >
                            <Icon size={16} />
                            {item.label}
                        </Link>
                    );
                })}
            </div>

            {/* Categories */}
            <div style={{ borderTop: '1px solid var(--border)', paddingTop: '0.5rem' }}>
                <button
                    onClick={() => setCollapsed(!collapsed)}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        width: '100%',
                        padding: '0.5rem 1rem',
                        background: 'transparent',
                        border: 'none',
                        color: 'var(--gold)',
                        fontSize: '0.8rem',
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        cursor: 'pointer',
                    }}
                >
                    <FolderOpen size={14} />
                    Categories
                    <span style={{ marginLeft: 'auto' }}>{collapsed ? <ChevronRight size={12} /> : <ChevronDown size={12} />}</span>
                </button>

                {!collapsed && (
                    <div style={{ padding: '0.25rem 0' }}>
                        {categories.map((cat) => {
                            const catPath = `/wiki/category/${cat.slug || cat.id}`;
                            const active = location.pathname.startsWith(catPath);
                            return (
                                <Link
                                    key={cat.id || cat.slug}
                                    to={catPath}
                                    style={{
                                        display: 'block',
                                        padding: '0.4rem 1rem 0.4rem 2.25rem',
                                        color: active ? 'var(--gold)' : 'var(--text-secondary)',
                                        background: active ? 'rgba(212,175,55,0.08)' : 'transparent',
                                        textDecoration: 'none',
                                        fontSize: '0.8rem',
                                    }}
                                >
                                    {cat.name}
                                </Link>
                            );
                        })}
                    </div>
                )}
            </div>

            {/* Quick links */}
            <div style={{ borderTop: '1px solid var(--border)', marginTop: '0.5rem', paddingTop: '0.5rem', padding: '0 0' }}>
                <Link
                    to="/wiki/drafts"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.65rem',
                        padding: '0.5rem 1rem',
                        color: location.pathname === '/wiki/drafts' ? 'var(--gold)' : 'var(--text-secondary)',
                        textDecoration: 'none',
                        fontSize: '0.875rem',
                        background: location.pathname === '/wiki/drafts' ? 'var(--gold-light)' : 'transparent',
                    }}
                >
                    <FileEdit size={16} /> My Drafts
                </Link>
                <Link
                    to="/wiki/mentions"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.65rem',
                        padding: '0.5rem 1rem',
                        color: location.pathname === '/wiki/mentions' ? 'var(--gold)' : 'var(--text-secondary)',
                        textDecoration: 'none',
                        fontSize: '0.875rem',
                        background: location.pathname === '/wiki/mentions' ? 'var(--gold-light)' : 'transparent',
                    }}
                >
                    <AtSign size={16} /> My Mentions
                </Link>
            </div>
        </nav>
    );
}